export const REGULATORY_ACCEPT = 'REGULATORY_ACCEPT';
export const LOADED_CONSENT_REQUEST = 'LOADED_CONSENT_REQUEST';
export const OAUTH_LOGO_UPDATE = 'OAUTH_LOGO_UPDATE';
export const OAUTH_UPDATE_DEVICE_APPNAME = 'OAUTH_UPDATE_DEVICE_APPNAME';